<template>
	<div class="row-fluid fondo-carro py-2">
		<div class="col-12 col-xl-8 offset-xl-2">
			<div class="row py-4 justify-content-center justify-content-md-end pr-md-5 pr-xl-5">
				<div class="fondo-formulario">
					<div class="container text-white text-center py-4 px-3 px-md-4 py-lg-5">
						<p class="fuente-titulo1 p-0 m-0">¿Interesado en ser</p>
						<p class="fuente-titulo2 p-0 m-0">nuestro cliente?</p>
						<p
							class="fuente-titulo3 p-0 m-0 text-left py-3 py-md-4 py-lg-4 py-xl-5"
						>Unos pocos datos bastan para brindarte atención.</p>
						<span @click="abreModal" class="link btn btn-block fuente-boton text-white">Contáctanos</span>
					</div>
				</div>
			</div>
		</div>

		<pm-modal-contacto :visible="mostrarModal" @close="mostrarModal = !mostrarModal" ></pm-modal-contacto>
	</div>
</template>

<script>
	import PmModalContacto from "@/components/publica/ModalContacto"

	export default {
		data() {
			return {				
				mostrarModal: false,				
			}
		},
		components: {
			PmModalContacto			
		},
		mounted() {			
			// this.ocultarChat();
		},
		methods: {	
			abreModal() {
				this.mostrarModal = true				
			},								
		}		
	}
</script>

<style scoped>
	.fondo-carro {
		background-image: url("../../assets/img-pub/Difarmer-formularioNuevo.png");
		background-size: cover;
		background-repeat: no-repeat;
	}
	.fondo-formulario {
		background-color: var(--color-amarillo);
		opacity: 0.9;
	}
	.fuente-titulo1 {
		font-weight: 600;
	}
	.fuente-titulo3 {
		font-family: "Open Sans", sans-serif;
	}
	.fuente-boton {
		font-family: "Open Sans", sans-serif;
		background-color: var(--color-amarillo) !important;
		border-color: var(--color-blanco) !important;
	}
	.fuente-boton:hover {
		background-color: var(--color-blanco) !important;
		border-color: var(--color-amarillo) !important;
		color: var(--color-amarillo) !important;
	}
	.fondo-modal {
		background-color: var(--color-gris-dark) !important;
	}
	.fuente-titulo-modal {
		font-weight: 600;
		color: var(--color-blanco) !important;
		font-style: italic;
	}
	.fuente-texto-modal {
		font-family: "Open Sans", sans-serif;
		color: var(--color-blanco) !important;
	}
	.fuente-label-modal {
		font-family: "Open Sans", sans-serif;
		color: var(--color-blanco) !important;
	}
	.fuente-caja-modal {
		font-family: "Open Sans", sans-serif;
		/*color: var(--color-azul) !important;*/
	}
	.fuente-boton-modal {
		background-color: var(--color-gris-dark) !important;
		border-color: var(--color-blanco) !important;
	}
	.fuente-boton-modal:hover {
		background-color: var(--color-blanco) !important;
		color: var(--color-gris-dark) !important;
		border-color: var(--color-gris-dark) !important;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-titulo1 {
			font-size: 20px !important;
		}
		.fuente-titulo2 {
			font-size: 20px !important;
		}
		.fuente-titulo3 {
			font-size: 14px !important;
		}
		.fondo-formulario {
			width: 270px;
		}
		.fuente-boton {
			font-size: 14px !important;
		}
		.fuente-titulo-modal {
			font-size: 20px !important;
		}
		.fuente-texto-modal {
			font-size: 14px !important;
		}
		.fuente-label-modal {
			font-size: 14px !important;
		}
		.fuente-caja-modal {
			font-size: 14px !important;
		}
		.fuente-boton-modal {
			font-size: 14px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-titulo1 {
			font-size: 20px !important;
		}
		.fuente-titulo2 {
			font-size: 20px !important;
		}
		.fuente-titulo3 {
			font-size: 16px !important;
		}
		.fondo-formulario {
			width: 350px;
		}
		.fuente-boton {
			font-size: 16px !important;
		}
		.fuente-titulo-modal {
			font-size: 20px !important;
		}
		.fuente-texto-modal {
			font-size: 16px !important;
		}
		.fuente-label-modal {
			font-size: 16px !important;
		}
		.fuente-caja-modal {
			font-size: 16px !important;
		}
		.fuente-boton-modal {
			font-size: 16px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-titulo1 {
			font-size: 20px !important;
		}
		.fuente-titulo2 {
			font-size: 20px !important;
		}
		.fuente-titulo3 {
			font-size: 16px !important;
		}
		.fondo-formulario {
			width: 310px;
		}
		.fuente-boton {
			font-size: 16px !important;
		}
		.fuente-titulo-modal {
			font-size: 20px !important;
		}
		.fuente-texto-modal {
			font-size: 16px !important;
		}
		.fuente-label-modal {
			font-size: 16px !important;
		}
		.fuente-caja-modal {
			font-size: 16px !important;
		}
		.fuente-boton-modal {
			font-size: 16px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-titulo1 {
			font-size: 28px !important;
		}
		.fuente-titulo2 {
			font-size: 28px !important;
		}
		.fuente-titulo3 {
			font-size: 18px !important;
		}
		.fondo-formulario {
			width: 400px;
		}
		.fuente-boton {
			font-size: 18px !important;
		}
		.fuente-titulo-modal {
			font-size: 28px !important;
		}
		.fuente-texto-modal {
			font-size: 18px !important;
		}
		.fuente-label-modal {
			font-size: 18px !important;
		}
		.fuente-caja-modal {
			font-size: 18px !important;
		}
		.fuente-boton-modal {
			font-size: 18px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-titulo1 {
			font-size: 41px !important;
		}
		.fuente-titulo2 {
			font-size: 41px !important;
		}
		.fuente-titulo3 {
			font-size: 20px !important;
		}
		.fondo-formulario {
			width: 550px;
		}
		.fuente-boton {
			font-size: 20px !important;
		}
		.fuente-titulo-modal {
			font-size: 41px !important;
		}
		.fuente-texto-modal {
			font-size: 20px !important;
		}
		.fuente-label-modal {
			font-size: 20px !important;
		}
		.fuente-caja-modal {
			font-size: 20px !important;
		}
		.fuente-boton-modal {
			font-size: 20px !important;
		}
	}
</style>